import { createApp } from 'vue'
import DeckPage from '../components/DeckPage.vue'

export function mountDeck() {
  const el = document.getElementById('deck-app')
  if (!el) return

  const app = createApp(DeckPage, {
    backUrl: el.dataset.backUrl,
  })
  app.mount(el)
}
